import { useLayoutEffect } from "react";
import { withRouter } from "../../helpers/withRouter";

const Scroll = ({ location }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export const ScrollToTop = withRouter(Scroll);
